package com.exura.ui

import com.exura.ui.Fonts.inter
import org.jetbrains.compose.web.css.StyleSheet
import org.jetbrains.compose.web.css.fontSize
import org.jetbrains.compose.web.css.fontWeight
import org.jetbrains.compose.web.css.px

object TextStyles : StyleSheet() {

    val normal10 by style {
        fontSize(10.px)
        fontWeight(400)
        inter()
    }


    val normal12 by style {
        fontSize(12.px)
        fontWeight(400)
        inter()
    }


    val normal14 by style {
        fontSize(14.px)
        fontWeight(400)
        inter()
    }


    val normal16 by style {
        fontSize(16.px)
        fontWeight(400)
        inter()
    }

    val normal18 by style {
        fontSize(18.px)
        fontWeight(400)
        inter()
    }

    val medium20 by style {
        fontSize(20.px)
        fontWeight(500)
        inter()
    }

    val medium12 by style {
        fontSize(12.px)
        fontWeight(500)
        inter()
    }

    val medium18 by style {
        fontSize(18.px)
        fontWeight(500)
        inter()
    }

    val medium16 by style {
        fontSize(16.px)
        fontWeight(500)
        inter()
    }

    val medium14 by style {
        fontSize(14.px)
        fontWeight(500)
        inter()
    }

    val medium24 by style {
        fontSize(24.px)
        fontWeight(500)
        inter()
    }

    val medium32 by style {
        fontSize(32.px)
        fontWeight(500)
        inter()
    }
}
